import React from 'react';
import T from '../../../../common/components/T';
import css from './PasswordRecoverTitle.module.scss';
import { generateUniqueId } from '../../../../common/utils/utils';
import Image from 'next/image';

const PasswordRecoverTitle = ({ complet }) => {
    if (complet) {
        return (
            <div className={css.authIconCompleetWrap} key={generateUniqueId()}>
                <div className={css.authIconCompleet}>
                    <Image fill src='/src/img/plugs/email.png' />
                </div>
                <p className={css.authHeadingTitle}>
                    <T textName='pass_recover_title' defaultStr='Восстановление пароля' page='/authentication' />
                </p>
                <p className={css.authHeadingText}>
                    <T
                        textName='pass_recover_alert'
                        defaultStr='На ваш email была отправлена инструкция по восстановлению пароля'
                        page='/authentication'
                    />
                </p>
            </div>
        );
    }
    return (
        <div className={css.authHeadingTitleWrap} key={generateUniqueId()}>
            <p className={css.authHeadingTitle}>
                <T textName='pass_recover_title' defaultStr='Восстановление пароля' page='/authentication' />
            </p>
            <p className={css.authHeadingText}>
                <T
                    textName='pass_recover_info'
                    defaultStr='Укажите свой логин или email и получите ссылку для восстановления'
                    page='/authentication'
                />
            </p>
        </div>
    );
};

export default PasswordRecoverTitle;
